<template>
    <!-- Start: Preview -->
    <main
        :style="{ 'background-color': back }"
        class="no-scrollbar flex-1 relative overflow-y-auto focus:outline-none ct-bg-2"
    >
        <div class="relative flex flex-1 min-h-full items-center justify-center overflow-hidden">
            <CardPreloader v-if="!iframeLoaded" />

            <iframe
                @load="setIframeLoaded()"
                class="transition-opacity"
                :class="[
                    iframeLoaded ? 'relative' : 'opacity-0 absolute',
                    size !== 'desktop' ? 'border-l border-r ct-border-2 border-dashed' : '',
                ]"
                id="iframe"
                :width="width ? width : screenWidth"
                :height="height ? height : 'auto'"
                :src="srcWithLang"
                frameborder="0"
                scrolling="no"
            ></iframe>
        </div>
    </main>
    <!-- End: Preview -->
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { CardPreloader } from "@easy/ui/cards";

export default {
    name: "vPreviewNew",
    components: { CardPreloader },
    props: {
        width: String,
        height: String,
        src: String,
        back: String,
    },
    emits: ["action"],
    computed: {
        ...mapState(["activeApp", "size", "view", "previewLang"]),
        ...mapGetters(["iframeLoaded"]),
        screenWidth() {
            let screenWidth = "";
            if (this.size === "mobile") screenWidth = "400px";
            if (this.size === "tablet") screenWidth = "1000px";
            if (this.size === "desktop") screenWidth = "100%";
            if (this.size === "tablet" && this.view === "mail") screenWidth = "600px";
            if (this.size === "desktop" && this.view === "mail") screenWidth = "600px";
            return screenWidth;
        },
        srcWithLang() {
            return `${this.src}${this.src.includes("?") ? "&" : "?"}lang=${this.previewLang}`;
        },
    },
    created() {
        window.onmessage = (e) => {
            if (e.data.frameHeight) {
                const iframe = document.getElementById("iframe");
                if (iframe) {
                    iframe.style.height = e.data.frameHeight;
                }
            }
            if (e.data.setView) {
                this.routeTo(e.data.setView);
            }
            if (e.data.setRoute) {
                const { name, query } = e.data.setRoute;
                this.$router.push({ name, query });
            }
            if (e.data.alert) {
                this.showAlert(e.data.alert);
            }
            if (e.data.action) {
                this.$emit("action", e.data.action);
            }
        };
    },
    methods: {
        ...mapMutations(["showAlert"]),
        ...mapActions(["setIframeLoaded"]),
        routeTo(forcedView) {
            const { name, query } = this.$route;
            this.$router.push({ name, query: { ...query, view: forcedView } });
        },
    },
};
</script>
